import React from 'react';
import './merchentpage.css'; 
import { Buildings, Location, Messages2, People, ShopAdd } from 'iconsax-react';
import {Link} from 'react-router-dom'; 

 const Addorganization = () => {
  return (
    <> 
    <div className="hader"> 
    <p> Add your organization</p>
    </div>
    <div className="form-container">
    <form className="custom-form">
      <div className="form-group">
        <label className="floating-label">
           Organization Name <span className="stag_star">*</span>
        </label>
        <input type="text" required className="form-input" />
      </div>

      <div className="form-group">
        <label className="floating-label">
          Mobile Number <span className="stag_star">*</span>
        </label>
        <input type="number" required className="form-input" />
      </div>
    </form>
   <div> 
   </div>
  </div>
  <div className='card_container'> 
  <div class="row">
    <div class="col">
    <div
     className='card_body'> 
    <p className='icon_sax_organization'> <span><Buildings
 size="25"
 color="#007bff"
 variant="Bulk"
/> 
</span> Invincix pvt ltd. </p>
    <p className='icon_sax_organization'> <span
    ><People size="25"
     color="#007bff" 
     variant="Bulk"/> </span> Softwer Company </p>
    <p  className='icon_sax_organization'> <span><Messages2
 size="25"
 color="#007bff"
 variant="Bulk"
/> </span> invincix@gmail.com</p>
    <p className='icon_sax_organization'> <span> <Location
 size="25"
 color="#007bff"
 variant="Bulk"
/></span> XYZ street, Lane-2 , Nagar , Cuttack , Odisha , 753014</p>
     </div>
    </div>
    <div class="col">
     <div
       className='card_body'> 
    <p className='icon_sax_organization'> <span><Buildings
 size="25"
 color="#007bff"
 variant="Bulk"
/> </span> Invincix pvt ltd. </p>
    <p className='icon_sax_organization'> <span
    ><People size="25"
     color="#007bff" 
     variant="Bulk"/> </span> Softwer Company </p>
    <p className='icon_sax_organization'> <span><Messages2
 size="25"
 color="#007bff"
 variant="Bulk"
/> </span> invincix@gmail.com</p>
    <p className='icon_sax_organization'> <span> <Location
 size="25"
 color="#007bff"
 variant="Bulk"
/></span> XYZ street, Lane-2 , Nagar , Cuttack , Odisha , 753014</p>
    
      </div>
    </div>
    <div class="col">
    <Link to="/gstpage"> 
    <div  className='card_body_add'> 
   <ShopAdd
 size="102"
 color="#007bff"
variant="Bulk"
/>
    </div>
       </Link>
    </div>
  </div>
  </div>
   </>
  )
}

export default Addorganization
